import * as React from "react"

export const EverriseLogo = ({ className, innerClassName }) => {
  return (
    <div className={`${className && className}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 3065 892"
        className={`${innerClassName && innerClassName} stroke-1`}
      >
        <path
          id="Selection"
          d="M 0.00,474.00
                       C 0.00,474.00 0.00,356.00 0.00,356.00
                         0.00,353.91 -0.12,350.94 0.60,349.00
                         2.03,345.10 11.62,336.38 15.00,333.00
                         15.00,333.00 57.00,291.00 57.00,291.00
                         57.00,291.00 229.00,119.00 229.00,119.00
                         229.00,119.00 313.00,35.00 313.00,35.00
                         313.00,35.00 337.00,11.00 337.00,11.00
                         339.19,8.81 345.48,2.04 348.00,1.17
                         352.59,-0.42 360.89,9.89 364.00,13.00
                         364.00,13.00 401.00,50.00 401.00,50.00
                         404.55,53.55 413.28,59.51 409.63,65.00
                         409.63,65.00 392.00,83.00 392.00,83.00
                         392.00,83.00 357.00,118.00 357.00,118.00
                         357.00,118.00 245.00,230.00 245.00,230.00
                         245.00,230.00 82.00,393.00 82.00,393.00
                         82.00,393.00 29.00,446.00 29.00,446.00
                         22.38,452.62 6.48,469.36 0.00,474.00 Z
                       M 0.00,683.00
                       C 0.00,683.00 0.00,566.00 0.00,566.00
                         0.00,563.91 -0.12,560.94 0.60,559.00
                         2.07,555.00 12.48,545.52 16.00,542.00
                         16.00,542.00 60.00,498.00 60.00,498.00
                         60.00,498.00 241.00,317.00 241.00,317.00
                         241.00,317.00 324.00,234.00 324.00,234.00
                         324.00,234.00 343.00,215.00 343.00,215.00
                         345.42,212.63 348.27,208.96 352.00,210.74
                         354.26,211.82 364.49,222.49 367.00,225.00
                         367.00,225.00 398.00,256.00 398.00,256.00
                         400.91,258.91 411.68,267.95 410.66,272.00
                         410.07,274.37 404.88,279.12 403.00,281.00
                         403.00,281.00 382.00,302.00 382.00,302.00
                         382.00,302.00 304.00,380.00 304.00,380.00
                         304.00,380.00 101.00,583.00 101.00,583.00
                         101.00,583.00 35.00,649.00 35.00,649.00
                         35.00,649.00 0.00,683.00 0.00,683.00 Z
                       M 2559.00,576.00
                       C 2570.90,594.21 2582.74,613.93 2604.00,622.55
                         2613.30,626.32 2628.02,629.01 2638.00,627.71
                         2668.70,623.72 2695.63,595.37 2696.00,564.00
                         2696.00,564.00 2696.00,555.00 2696.00,555.00
                         2695.96,532.25 2684.76,511.51 2667.00,497.52
                         2658.61,490.91 2645.67,484.59 2636.00,479.75
                         2636.00,479.75 2589.00,454.85 2589.00,454.85
                         2572.29,445.31 2559.33,438.03 2547.74,422.00
                         2532.67,401.14 2527.71,375.32 2528.00,350.00
                         2528.74,286.92 2577.40,235.75 2641.00,235.00
                         2673.69,234.62 2706.16,247.26 2728.96,271.00
                         2735.70,278.02 2742.39,287.49 2747.14,296.00
                         2748.53,298.50 2751.85,304.10 2751.19,306.91
                         2750.57,309.56 2747.09,311.78 2745.00,313.29
                         2739.59,317.20 2733.86,321.99 2728.00,325.00
                         2717.93,303.65 2705.53,284.01 2683.00,274.01
                         2666.62,266.79 2646.20,265.65 2630.00,274.01
                         2609.97,284.28 2597.26,309.96 2597.00,332.00
                         2596.91,339.67 2596.82,346.52 2599.04,354.00
                         2608.92,387.26 2645.36,399.36 2673.00,414.31
                         2689.28,423.11 2722.57,441.04 2735.00,453.04
                         2754.53,471.92 2761.55,495.84 2764.17,522.00
                         2764.17,522.00 2765.00,531.00 2765.00,531.00
                         2765.21,549.04 2763.51,566.91 2757.31,584.00
                         2746.04,615.04 2721.17,639.30 2691.00,652.13
                         2671.73,660.32 2654.36,660.23 2634.00,660.00
                         2604.95,659.66 2575.55,648.70 2555.00,628.00
                         2547.62,620.57 2535.93,606.05 2533.00,596.00
                         2533.00,596.00 2559.00,576.00 2559.00,576.00 Z
                       M 680.00,246.00
                       C 680.00,246.00 893.00,246.00 893.00,246.00
                         893.00,246.00 893.00,273.00 893.00,273.00
                         893.00,273.00 748.00,273.00 748.00,273.00
                         748.00,273.00 748.00,427.00 748.00,427.00
                         748.00,427.00 884.00,427.00 884.00,427.00
                         884.00,427.00 884.00,454.00 884.00,454.00
                         884.00,454.00 748.00,454.00 748.00,454.00
                         748.00,454.00 748.00,622.00 748.00,622.00
                         748.00,622.00 895.00,622.00 895.00,622.00
                         895.00,622.00 895.00,649.00 895.00,649.00
                         895.00,649.00 680.00,649.00 680.00,649.00
                         680.00,649.00 680.00,246.00 680.00,246.00 Z
                       M 968.00,246.00
                       C 968.00,246.00 1031.00,246.00 1031.00,246.00
                         1031.00,246.00 1038.58,247.02 1038.58,247.02
                         1038.58,247.02 1045.42,262.00 1045.42,262.00
                         1045.42,262.00 1062.68,308.00 1062.68,308.00
                         1062.68,308.00 1111.58,438.00 1111.58,438.00
                         1111.58,438.00 1139.00,510.00 1139.00,510.00
                         1139.00,510.00 1146.00,488.00 1146.00,488.00
                         1146.00,488.00 1162.00,442.00 1162.00,442.00
                         1162.00,442.00 1190.66,359.00 1190.66,359.00
                         1190.66,359.00 1208.95,306.00 1208.95,306.00
                         1208.95,306.00 1224.00,262.00 1224.00,262.00
                         1224.00,262.00 1230.51,247.02 1230.51,247.02
                         1230.51,247.02 1238.00,246.00 1238.00,246.00
                         1238.00,246.00 1263.00,246.00 1263.00,246.00
                         1263.00,246.00 1256.00,267.00 1256.00,267.00
                         1256.00,267.00 1236.67,323.00 1236.67,323.00
                         1236.67,323.00 1164.33,534.00 1164.33,534.00
                         1164.33,534.00 1135.00,620.00 1135.00,620.00
                         1135.00,620.00 1126.33,645.00 1126.33,645.00
                         1126.33,645.00 1120.00,660.00 1120.00,660.00
                         1120.00,660.00 1104.31,618.00 1104.31,618.00
                         1104.31,618.00 1082.95,560.00 1082.95,560.00
                         1082.95,560.00 1019.95,389.00 1019.95,389.00
                         1019.95,389.00 984.95,294.00 984.95,294.00
                         984.95,294.00 968.00,246.00 968.00,246.00 Z
                       M 1335.00,246.00
                       C 1335.00,246.00 1548.00,246.00 1548.00,246.00
                         1548.00,246.00 1548.00,273.00 1548.00,273.00
                         1548.00,273.00 1404.00,273.00 1404.00,273.00
                         1404.00,273.00 1404.00,427.00 1404.00,427.00
                         1404.00,427.00 1540.00,427.00 1540.00,427.00
                         1540.00,427.00 1540.00,454.00 1540.00,454.00
                         1540.00,454.00 1404.00,454.00 1404.00,454.00
                         1404.00,454.00 1404.00,622.00 1404.00,622.00
                         1404.00,622.00 1550.00,622.00 1550.00,622.00
                         1550.00,622.00 1550.00,649.00 1550.00,649.00
                         1550.00,649.00 1335.00,649.00 1335.00,649.00
                         1335.00,649.00 1335.00,246.00 1335.00,246.00 Z
                       M 1646.00,246.00
                       C 1646.00,246.00 1779.00,246.00 1779.00,246.00
                         1813.81,246.00 1846.41,245.06 1875.00,268.62
                         1887.69,279.07 1896.02,295.39 1900.42,311.00
                         1907.96,337.71 1908.13,369.60 1899.33,396.00
                         1895.67,407.00 1890.27,419.12 1882.70,428.00
                         1866.77,446.68 1835.21,459.02 1811.00,461.00
                         1811.00,461.00 1831.75,503.00 1831.75,503.00
                         1831.75,503.00 1878.25,595.00 1878.25,595.00
                         1878.25,595.00 1892.31,623.00 1892.31,623.00
                         1892.31,623.00 1905.00,649.00 1905.00,649.00
                         1905.00,649.00 1838.00,649.00 1838.00,649.00
                         1838.00,649.00 1829.65,647.40 1829.65,647.40
                         1829.65,647.40 1822.75,634.00 1822.75,634.00
                         1822.75,634.00 1807.00,601.00 1807.00,601.00
                         1807.00,601.00 1789.31,564.00 1789.31,564.00
                         1789.31,564.00 1755.74,493.00 1755.74,493.00
                         1755.74,493.00 1732.00,442.00 1732.00,442.00
                         1732.00,442.00 1746.00,442.00 1746.00,442.00
                         1765.86,441.97 1791.50,435.24 1807.00,422.54
                         1814.61,416.30 1821.62,407.82 1826.03,399.00
                         1842.19,366.68 1837.31,313.99 1810.83,288.29
                         1784.58,262.80 1747.51,267.00 1714.00,267.00
                         1714.00,267.00 1714.00,649.00 1714.00,649.00
                         1714.00,649.00 1646.00,649.00 1646.00,649.00
                         1646.00,649.00 1646.00,246.00 1646.00,246.00 Z
                       M 2006.00,246.00
                       C 2006.00,246.00 2164.00,246.00 2164.00,246.00
                         2164.00,246.00 2174.00,246.91 2174.00,246.91
                         2195.05,248.38 2216.38,253.47 2233.00,267.32
                         2254.50,285.24 2264.96,316.57 2265.00,344.00
                         2265.00,344.00 2265.00,364.00 2265.00,364.00
                         2264.95,374.47 2261.98,387.07 2258.67,397.00
                         2254.53,409.42 2248.58,421.21 2239.71,430.96
                         2225.36,446.74 2191.25,460.02 2170.00,461.00
                         2170.00,461.00 2192.25,505.00 2192.25,505.00
                         2192.25,505.00 2224.25,568.00 2224.25,568.00
                         2224.25,568.00 2244.26,608.00 2244.26,608.00
                         2244.26,608.00 2265.00,649.00 2265.00,649.00
                         2265.00,649.00 2197.00,649.00 2197.00,649.00
                         2187.62,648.98 2189.69,648.89 2183.25,636.00
                         2183.25,636.00 2167.14,602.00 2167.14,602.00
                         2167.14,602.00 2149.78,566.00 2149.78,566.00
                         2149.78,566.00 2116.74,496.00 2116.74,496.00
                         2116.74,496.00 2098.58,458.00 2098.58,458.00
                         2096.16,452.46 2093.13,448.00 2092.00,442.00
                         2092.00,442.00 2106.00,442.00 2106.00,442.00
                         2129.11,441.96 2154.99,433.86 2171.96,417.83
                         2186.57,404.03 2192.23,385.35 2194.17,366.00
                         2197.07,336.97 2189.63,305.08 2167.00,285.18
                         2141.76,262.99 2105.15,267.00 2074.00,267.00
                         2074.00,267.00 2074.00,649.00 2074.00,649.00
                         2074.00,649.00 2006.00,649.00 2006.00,649.00
                         2006.00,649.00 2006.00,246.00 2006.00,246.00 Z
                       M 2362.00,246.00
                       C 2362.00,246.00 2430.00,246.00 2430.00,246.00
                         2430.00,246.00 2430.00,649.00 2430.00,649.00
                         2430.00,649.00 2362.00,649.00 2362.00,649.00
                         2362.00,649.00 2362.00,246.00 2362.00,246.00 Z
                       M 2851.00,246.00
                       C 2851.00,246.00 3064.00,246.00 3064.00,246.00
                         3064.00,246.00 3064.00,273.00 3064.00,273.00
                         3064.00,273.00 2919.00,273.00 2919.00,273.00
                         2919.00,273.00 2919.00,427.00 2919.00,427.00
                         2919.00,427.00 3055.00,427.00 3055.00,427.00
                         3055.00,427.00 3055.00,454.00 3055.00,454.00
                         3055.00,454.00 2919.00,454.00 2919.00,454.00
                         2919.00,454.00 2919.00,622.00 2919.00,622.00
                         2919.00,622.00 3065.00,622.00 3065.00,622.00
                         3065.00,622.00 3065.00,649.00 3065.00,649.00
                         3065.00,649.00 2851.00,649.00 2851.00,649.00
                         2851.00,649.00 2851.00,246.00 2851.00,246.00 Z
                       M 349.00,418.00
                       C 354.87,422.21 361.71,429.71 367.00,435.00
                         367.00,435.00 397.00,465.00 397.00,465.00
                         400.01,468.01 411.69,477.91 410.66,482.00
                         410.07,484.37 404.88,489.12 403.00,491.00
                         403.00,491.00 384.00,510.00 384.00,510.00
                         384.00,510.00 311.00,583.00 311.00,583.00
                         311.00,583.00 95.00,799.00 95.00,799.00
                         95.00,799.00 31.00,863.00 31.00,863.00
                         31.00,863.00 13.00,881.00 13.00,881.00
                         8.88,885.12 5.32,889.48 0.00,892.00
                         0.00,892.00 0.00,775.00 0.00,775.00
                         0.00,775.00 0.60,768.00 0.60,768.00
                         0.60,768.00 8.00,759.00 8.00,759.00
                         8.00,759.00 22.00,745.00 22.00,745.00
                         22.00,745.00 87.00,680.00 87.00,680.00
                         87.00,680.00 349.00,418.00 349.00,418.00 Z"
        />
      </svg>
    </div>
  )
}
